module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "issue-badge"
  }, [_c('div', {
    staticClass: "column--left"
  }, [_c('img', {
    staticClass: "issue-badge__icon",
    attrs: {
      "src": _vm.getIcon(_vm.issue.issueType)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "issue-badge__text"
  }, [_c('div', {
    staticClass: "issue-badge__text-type"
  }, [_vm._v(_vm._s(_vm.getType(_vm.issue.issueType)))]), _vm._v(" "), (_vm.issue.serviceProvider != null || _vm.userGroup == 'hsg-admins') ? _c('div', {
    staticClass: "issue-badge__issue-status"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.issueSelectorOpen === true) ? _c('div', {
    staticClass: "issue-badge__issue-status-selector"
  }, [_c('p', {
    staticClass: "title",
    on: {
      "click": function($event) {
        _vm.issueSelectorOpen = false
      }
    }
  }, [_vm._v("Select issue status "), _c('span', {
    staticClass: "chevron"
  })]), _vm._v(" "), (_vm.userGroup == 'hsg-admins' || _vm.userGroup == 'multi-site-retailers' || _vm.userGroup == 'retailers') ? _c('p', {
    on: {
      "click": function($event) {
        _vm.setIssueStatus('unread')
      }
    }
  }, [_c('span', {
    staticClass: "status-badge unread"
  }), _vm._v("Unread")]) : _vm._e(), _vm._v(" "), (_vm.userGroup == 'hsg-admins' || _vm.userGroup == 'multi-site-retailers' || _vm.userGroup == 'retailers') ? _c('p', {
    on: {
      "click": function($event) {
        _vm.setIssueStatus('resolved-by-retailer')
      }
    }
  }, [_c('span', {
    staticClass: "status-badge resolved-by-retailer"
  }), _vm._v("Resolved By Retailer")]) : _vm._e(), _vm._v(" "), (_vm.userGroup == 'hsg-admins' || _vm.userGroup == 'multi-site-retailers' || _vm.userGroup == 'retailers') ? _c('p', {
    on: {
      "click": function($event) {
        _vm.setIssueStatus('confirmed')
      }
    }
  }, [_c('span', {
    staticClass: "status-badge confirmed"
  }), _vm._v("Confirmed")]) : _vm._e(), _vm._v(" "), (_vm.userGroup == 'hsg-admins' || _vm.userGroup == 'multi-site-retailers' || _vm.userGroup == 'retailers') ? _c('p', {
    on: {
      "click": function($event) {
        _vm.setIssueStatus('denied')
      }
    }
  }, [_c('span', {
    staticClass: "status-badge denied"
  }), _vm._v("Denied")]) : _vm._e(), _vm._v(" "), (_vm.userGroup == 'hsg-admins' || _vm.userGroup == 'service-providers') ? _c('p', {
    on: {
      "click": function($event) {
        _vm.setIssueStatus('resolution-in-progress')
      }
    }
  }, [_c('span', {
    staticClass: "status-badge resolution-in-progress"
  }), _vm._v("Resolution In Progress")]) : _vm._e(), _vm._v(" "), (_vm.userGroup == 'hsg-admins' || _vm.userGroup == 'service-providers') ? _c('p', {
    on: {
      "click": function($event) {
        _vm.setIssueStatus('resolution-awaiting-approval')
      }
    }
  }, [_c('span', {
    staticClass: "status-badge resolution-awaiting-approval"
  }), _vm._v("Resolution Awaiting Approval")]) : _vm._e(), _vm._v(" "), (_vm.userGroup == 'hsg-admins' || _vm.userGroup == 'multi-site-retailers' || _vm.userGroup == 'retailers') ? _c('p', {
    on: {
      "click": function($event) {
        _vm.setIssueStatus('resolution-accepted')
      }
    }
  }, [_c('span', {
    staticClass: "status-badge resolution-accepted"
  }), _vm._v("Resolution Accepted")]) : _vm._e(), _vm._v(" "), (_vm.userGroup == 'hsg-admins' || _vm.userGroup == 'multi-site-retailers' || _vm.userGroup == 'retailers') ? _c('p', {
    on: {
      "click": function($event) {
        _vm.setIssueStatus('resolution-denied')
      }
    }
  }, [_c('span', {
    staticClass: "status-badge resolution-denied"
  }), _vm._v("Resolution Denied")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "issue-badge__issue-status-text",
    class: {
      'disabled': _vm.userGroup == 'multi-site-retailers'
    },
    on: {
      "click": function($event) {
        _vm.openIssueSelector()
      }
    }
  }, [_vm._v("\n          Status: "), _c('span', {
    staticClass: "capitalise"
  }, [_c('span', {
    staticClass: "status-badge",
    class: _vm.issue.status
  }), _vm._v(_vm._s(_vm.issue.status))]), _vm._v(" "), (_vm.userGroup != 'multi-site-retailers') ? _c('span', {
    staticClass: "chevron"
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.issue.issueType == 'customsuggestion') ? _c('div', {
    staticClass: "issue-badge__text-custom-suggestion"
  }, [_vm._v("\n        " + _vm._s(_vm.issue.customSuggestionText) + "\n      ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "column--right"
  }, [(_vm.issue.s3ImageUrl) ? _c('div', {
    staticClass: "review-image",
    style: ({
      backgroundImage: 'url(' + _vm.image + ')'
    }),
    on: {
      "click": function($event) {
        _vm.showOverlay = true
      }
    }
  }) : _c('div', {
    staticClass: "review-image placeholder",
    style: ({
      backgroundImage: 'url(/static/img/image-placeholder.svg)'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "image-link"
  }, [_c('p', {
    class: {
      disabled: !_vm.issue.s3ImageUrl
    },
    on: {
      "click": function($event) {
        _vm.showOverlay = true
      }
    }
  }, [_vm._v("View Image")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "appear": ""
    }
  }, [(_vm.showOverlay === true) ? _c('div', {
    staticClass: "image-overlay",
    on: {
      "click": function($event) {
        _vm.showOverlay = false
      }
    }
  }, [_c('div', {
    staticClass: "image-container",
    on: {
      "click": function($event) {
        _vm.preventBubble($event)
      }
    }
  }, [_c('img', {
    staticClass: "close",
    attrs: {
      "src": "/static/img/icon__close--light.svg"
    },
    on: {
      "click": function($event) {
        _vm.showOverlay = false
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.image
    },
    on: {
      "click": function($event) {
        _vm.preventBubble($event)
      }
    }
  })])]) : _vm._e()])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-97da5702","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/IssueBadge/IssueBadge.vue
// module id = 563
// module chunks = 1